import React from "react";
import NotFound from "./NotFound";

function Connections() {
  return (
    <div className="unloadPage">
      <NotFound />
    </div>
  );
}

export default Connections;
